import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Clearfix, Button } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';
import { map as _map, toString as _toString, pullAll as _pullAll, concat as _concat } from 'lodash';

import { setFilter } from 'actions/SummaryActions';
import { parseQs, stringifyQs } from 'helpers/http';

import VklFilterDesktopValue from 'components/layout/vkl/VklFilterDesktopValue';

class VklFilterDesktop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mouseOver: false,
      show: false,
      newValues: [],
      removeValues: [],
    };

    this.optionsRef = React.createRef();
  }

  componentWillUnmount = () => {
    document.removeEventListener('click', this.outsideClick, false);
  };

  handleClick = () => {
    document.addEventListener('click', this.outsideClick, false);
    this.setState({ show: true });
  };

  hide = () => {
    const { newValues, removeValues } = this.state;

    if (newValues.length || removeValues.length) {
      this.setFilter();
    } else {
      this.setState({ show: false });
      document.removeEventListener('click', this.outsideClick, false);
    }
  };

  outsideClick = e => {
    if (this.optionsRef.current.contains(e.target)) {
      return;
    }
    this.hide();
  };

  getName = () => {
    const { facet } = this.props;
    return facet.name;
  };

  valueClick = (value, checked) => {
    const currentNewIndex = this.state.newValues.indexOf(value);
    const currentRemoveIndex = this.state.removeValues.indexOf(value);
    const stateIndex =
      this.props.filters[this.getName()] !== undefined ? this.props.filters[this.getName()].indexOf(value) : -1;

    if (checked) {
      if (currentRemoveIndex > -1) {
        // value is already in state, user wanted to remove it at first, but then changed his mind
        let removeValues = this.state.removeValues.slice();
        removeValues.splice(currentRemoveIndex, 1);
        this.setState({ removeValues });
      } else if (stateIndex === -1) {
        // add new value
        let newValues = this.state.newValues.slice();
        newValues.push(value);
        this.setState({ newValues });
      }
    } else if (currentNewIndex > -1) {
      /*  */
      // user wanted to filter, but he changes his mind
      let newValues = this.state.newValues.slice();
      newValues.splice(currentNewIndex, 1);
      this.setState({ newValues });
    } else {
      // filter is already in state
      // user wanted to disable it, but now he changed his mind
      let removeValues = this.state.removeValues.slice();
      removeValues.push(value);
      this.setState({ removeValues });
    }
  };

  setFilter = () => {
    // some values are integers (year / month), so we have to convert the value first
    let removeValues = _map(this.state.removeValues, value => {
      return _toString(value);
    });
    let newValues = _map(this.state.newValues, value => {
      return _toString(value);
    });

    let values = this.props.filters[this.getName()] !== undefined ? this.props.filters[this.getName()].slice() : [];
    values = _pullAll(values, removeValues);
    values = _concat(values, newValues);

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: stringifyQs({ ...parseQs(this.props.location.search), [this.getName()]: values }),
    });
    this.setState({ newValues: [], removeValues: [] }, () => {
      this.hide();
    });
  };

  isValueChecked = value => {
    const currentNewIndex = this.state.newValues.indexOf(value);
    const currentRemoveIndex = this.state.removeValues.indexOf(value);
    const stateIndex =
      this.props.filters[this.getName()] !== undefined
        ? _toString(this.props.filters[this.getName()]).indexOf(_toString(value))
        : -1;

    if (currentNewIndex > -1) {
      return true;
    }

    if (stateIndex > -1 && currentRemoveIndex === -1) {
      return true;
    }

    return false;
  };

  hasFilters = () => {
    return this.props.filters[this.getName()] !== undefined;
  };

  getFilterName = name => {
    const {
      intl: { messages },
    } = this.props;

    // TODO: auch bei mobiler Anzeige übersetzen
    const mapping = {
      salesmanLastname: messages.sad.salesman,
      salesmanId: messages.sad.salesman,
      salesmanIdBlacklist: messages.sad.salesman_blacklist,
      carModelName: messages.car + '-' + messages.sad.class,
      salesDescriptionShort: messages.car + '-' + messages.model,
      carTypeName: messages.sad.body_design,
      carColor: messages.sad.car_color,
      companyMainNumber: messages.company,
      salesmanCompanyNumber: messages.sad.store,
      year: messages.year,
      month: messages.month,
      status: messages.status,
      source: messages.source,
      isInternalActivity: messages.sad.internal_activity,
    };

    if (mapping.hasOwnProperty(name)) {
      return mapping[name];
    }
    return name;
  };

  render() {
    const {
      intl: { messages },
      facet,
    } = this.props;
    const { mouseOver, show } = this.state;

    return (
      <div class="relative">
        <div
          class={'animate-all b-a b-thick p-l-15 p-r-15 p-t-5 p-b-5 cursor ' + (mouseOver || show ? '' : 'b-grey ')}
          onMouseEnter={() => this.setState({ mouseOver: true })}
          onMouseLeave={() => this.setState({ mouseOver: false })}
          onClick={this.handleClick}
        >
          <Clearfix class="fs-12">
            <div class="pull-left text-black">{this.getFilterName(facet.name)}</div>{' '}
            {/* filter name comes already with the name in proper language */}
            <div class="pull-right">
              {this.hasFilters() && !show ? (
                <i class="fa fa-check text-success" />
              ) : (
                <i class={'fa fa-angle-' + (show ? 'up' : 'down')} />
              )}
            </div>
          </Clearfix>
        </div>

        <div
          ref={this.optionsRef}
          class={'overlayer full-width bg-white ' + (show ? 'block b-a b-thick' : 'hide ')}
          style={{ borderTopWidth: 0, marginTop: '-2px' }}
        >
          <AnimateHeight duration={200} height={show ? 'auto' : 0}>
            <div class="p-t-15" style={{ maxHeight: '50vh', overflowY: 'auto' }}>
              {facet.values.map((value, i) => {
                return (
                  <VklFilterDesktopValue
                    type={facet.type}
                    facetName={facet.name}
                    value={value}
                    checked={this.isValueChecked(value._id)}
                    yesMessage={messages.yes}
                    onClick={this.valueClick}
                    key={i}
                  />
                );
              })}
            </div>
            <div class="m-t-10 padding-10">
              {this.state.newValues.length || this.state.removeValues.length ? (
                <Button
                  block
                  bsSize="lg"
                  class="text-uppercase bold"
                  bsStyle="primary"
                  onClick={() => this.setFilter()}
                >
                  {messages.save}
                </Button>
              ) : (
                <Button block bsSize="lg" class="text-uppercase bold text-black" onClick={() => this.hide()}>
                  {messages.close}
                </Button>
              )}
            </div>
          </AnimateHeight>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setFilter: (name, values) => {
      dispatch(setFilter(name, values));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(VklFilterDesktop)
  )
);
